import useHttp from 'helpers/HttpMethods';
import { SearchSettings, SearchSettingsInput } from 'types/SearchSettingsTypes';

const http = useHttp();
class SearchSettingsService {
  static async findByUser(): Promise<SearchSettings> {
    return await http.get('/search-settings');
  }

  static async edit(body: SearchSettingsInput): Promise<SearchSettings> {
    return await http.put(body, '/search-settings');
  }
}

export default SearchSettingsService;
